// extracted by mini-css-extract-plugin
export default {"checkout_summary":"FA","checkout_summary_wrapper":"GA","summary_items":"HA","line_items_wrapper":"IA","separator":"JA","order_summary":"KA","line_item":"LA","order__summary_item_title":"MA","recurringdis":"NA","note":"OA","carbon_emission":"PA","unlock_savings":"QA","member_perk":"RA","info":"SA","no_items":"TA","promo":"UA","order_summary_mobile":"VA","open_summary_mobile":"WA","fixed_bottom_info":"XA","open_info":"YA","text":"ZA","open_summary":"aB"};
    if(module.hot) {
      // 1711717533336
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  